import {ref} from 'vue';
import type {FormElementItem} from '~/lib/types/formTypes';

export const useFineAndKinney = () => {
	const formSchema: Array<FormElementItem> = [
		{
			key: 'exposure',
			label: 'Blootstellingsfrequentie',
			type: 'select',
			options: [
				{value: '10', label: 'voortdurend'},
				{value: '6', label: 'regelmatig (dagelijks)'},
				{value: '3', label: 'af en toe (wekelijks)'},
				{value: '2', label: 'soms (maandelijks)'},
				{value: '1', label: 'zelden (jaarlijks)'},
				{value: '0.5', label: 'zeer zelden (minder dan 1 keer/jaar)'}
			],
			validators: {}
		},
		{
			key: 'effect',
			label: 'Effect',
			type: 'select',
			options: [
				{value: '40', label: 'Ramp, meerdere doden'},
				{value: '15', label: 'Zeer ernstig, één dode'},
				{value: '7', label: 'Aanzienlijk, ernstige verwondingen, invaliditeit'},
				{value: '3', label: 'Belangrijk, letsel, werkonderbreking'},
				{value: '1', label: 'Betekenisvol, EHBO kan nodig zijn'}
			],
			validators: {}
		},
		{
			key: 'probability',
			label: 'Waarschijnlijkheid',
			type: 'select',
			options: [
				{value: '10', label: 'zo goed als zeker'},
				{value: '6', label: 'zeer goed mogelijk'},
				{value: '3', label: 'waarschijnlijk'},
				{value: '1', label: 'mogelijk, maar onwaarschijnlijk'},
				{value: '0.5', label: 'zeer zelden (zeer onwaarschijnlijk)'},
				{value: '0.2', label: 'praktisch onmogelijk'},
				{value: '0.1', label: 'zo goed als ondenkbaar'}
			],
			validators: {}
		}
	];

	const formFields = ref({
		exposure: '',
		effect: '',
		probability: ''
	});

	return {
		formFields,
		formSchema
	};

};
